import alt from 'alt'
import Immutable from 'immutable'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { CheckActions } from 'actions'
import { browserHistory } from 'react-router'
import Enum from 'utils/Enum'

@createStore(alt)
export default class CheckStore {
  static displayName = 'CheckStore'

  constructor() {
    this.state = {
      checks: Immutable.List([]),
      checkActivated: false,
      checkUpdated: false
    }

    this.bindActions(CheckActions)
  }

  setChecks({ setups, checks }) {
    let mergedChecks = []

    for (let key in Enum.CheckTypes) {
      const type  = Enum.CheckTypes[key]
      const check = checks.find(x => x.typeId === type.id)
      const setup = setups.find(x => x.typeId === type.id)

      if  (!setup) {
        continue
      }

      let mergedCheck = {
        typeId:        type.id,
        name:          type.name,
        key:           key,
        isBlog:        false,
        disableable:   type.disableable,
        enabled:       false,
        onlyForPlus:   type.onlyForPlus,
        url:           setup.url,
        executeResult: null,
      }

      if (check) {
        mergedCheck.checkId         = check.id
        mergedCheck.enabled         = check.enabled
        mergedCheck.verdict         = check.verdict
        mergedCheck.verdictFriendly = check.verdictFriendly
      }

      if (setup.typeId === Enum.CheckTypes.blog.id) {
        mergedCheck.blogUrl     = setup.blogUrl
        mergedCheck.feedUrl     = setup.feedUrl
        mergedCheck.warnDays    = setup.warnDays
        mergedCheck.critialDays = setup.critialDays
      } else if (setup.typeId === Enum.CheckTypes.notfound.id) {
        mergedCheck.warnHits        = setup.warnHits
        mergedCheck.criticalHits    = setup.criticalHits
        mergedCheck.verdict         = setup.verdict
        mergedCheck.verdictFriendly = setup.verdictFriendly
      } else if (setup.typeId === Enum.CheckTypes.seoproblems.id) {
        mergedCheck.keywords = setup.keywords
      }

      mergedChecks.push(mergedCheck)
    }

    this.setState({ checks: Immutable.fromJS(mergedChecks) })
  }

  activatingCheck() {
    this.setState({ checkActivated: false })
  }

  checkActivated(typeId) {
    const checks = this.state.checks.map(check => {
      if (check.get('typeId') != typeId) return check

      return check
        // .set('userCheckId', activatedCheck.id)
        // .set('verdict', activatedCheck.verdict)
        // .set('verdictFriendly', activatedCheck.verdictFriendly)
        // .set('executeResult', activatedCheck.executeResult)
        .set('enabled', true)
        // .set('url', activatedCheck.url)
        // .set('blogUrl', activatedCheck.blogUrl)
        // .set('feedUrl', activatedCheck.feedUrl)
        // .set('warnDays', activatedCheck.warnDays)
        // .set('criticalDays', activatedCheck.criticalDays)
    })

    this.setState({ checks, checkActivated: true })
  }

  updatingCheck() {
    this.setState({ checkUpdated: false })
  }

  checkUpdated(updatedCheck) {
    const checks = this.state.checks.map(check => {
      if (check.get('typeId') != updatedCheck.typeId) return check

      return check
        .set('userCheckId', updatedCheck.id)
        .set('verdict', updatedCheck.verdict)
        .set('verdictFriendly', updatedCheck.verdictFriendly)
        .set('executeResult', updatedCheck.executeResult)
        .set('exception', updatedCheck.exception)
        .set('enabled', updatedCheck.enabled)
        .set('url', updatedCheck.url)
        .set('blogUrl', updatedCheck.blogUrl)
        .set('feedUrl', updatedCheck.feedUrl)
        .set('warnDays', updatedCheck.warnDays)
        .set('criticalDays', updatedCheck.criticalDays)
    })

    this.setState({ checks, checkUpdated: true })
  }

  setCheckActivated(checkActivated) {
    this.setState({ checkActivated })
  }

  setCheckStatus({ typeId, verdict, verdictFriendly, executeResult, exception }) {
    const updated = this.state.checks.map(x => {
      if (x.get('typeId') !== typeId) return x

      return x.set('verdictFriendly', verdictFriendly)
        .set('verdict', verdict)
        .set('executeResult', executeResult)
        .set('exception', exception)
    })

    this.setState({ checks: updated })
  }
}



// WEBPACK FOOTER //
// ./app/stores/CheckStore.js